'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/button.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
HeaderButton.propTypes = {
  text: _propTypes.string.isRequired,
  to: _propTypes.string,
  onClick: _propTypes.func,
  css: _propTypes.object
};
HeaderButton.defaultProps = {
  to: undefined,
  onClick: undefined,
  css: undefined
};
function HeaderButton(_ref) {
  var css = _ref.css,
    to = _ref.to,
    text = _ref.text,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, ['css', 'to', 'text', 'onClick']);
  var buttonCss = Object.assign({
    marginBottom: 0
  }, css);
  var defaultProps = Object.assign({
    css: buttonCss,
    prominence: 'primary'
  }, rest);
  if (typeof to !== 'undefined') {
    return _react2.default.createElement(_button.LinkButton, Object.assign({
      to: to
    }, defaultProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      },
      __self: this
    }), text);
  }
  return _react2.default.createElement(_button2.default, Object.assign({
    onClick: onClick
  }, defaultProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }), text);
}
exports.default = HeaderButton;